var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"app",attrs:{"id":"app"}},[_c('router-view'),(_vm.isShowFooterNav)?_c('MobileFooterNav'):_vm._e(),_c('BackTop',{staticClass:"hidden-xs-only"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }